module.exports = __webpack_public_path__ + "img/md-warning.2f8f481c.svg";